import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=61aeae3a&scoped=true&lang=pug&"
import script from "./TextEllipsis.vue?vue&type=script&lang=js&"
export * from "./TextEllipsis.vue?vue&type=script&lang=js&"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=61aeae3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aeae3a",
  null
  
)

export default component.exports